import { createSelector } from 'reselect';
import moment from 'moment';

export const Types = {
  GET_REQUEST: 'interviews/GET_REQUEST',
  GET_SUCCESS: 'interviews/GET_SUCCESS',
  GET_FAILURE: 'interviews/GET_FAILURE',

  GET_LIST_REQUEST: 'interviews/GET_LIST_REQUEST',
  GET_LIST_SUCCESS: 'interviews/GET_LIST_SUCCESS',
  GET_LIST_FAILURE: 'interviews/GET_LIST_FAILURE',

  CREATE_REQUEST: 'interviews/CREATE_REQUEST',
  CREATE_SUCCESS: 'interviews/CREATE_SUCCESS',
  CREATE_FAILURE: 'interviews/CREATE_FAILURE',

  UPDATE_REQUEST: 'interviews/UPDATE_REQUEST',
  UPDATE_SUCCESS: 'interviews/UPDATE_SUCCESS',
  UPDATE_FAILURE: 'interviews/UPDATE_FAILURE',

  DELETE_REQUEST: 'interviews/DELETE_REQUEST',
  DELETE_SUCCESS: 'interviews/DELETE_SUCESS',
  DELETE_FAILURE: 'interviews/DELETE_FAILURE',

  GET_INTERVIEWABLES_REQUEST: 'interviews/GET_INTERVIEWABLES_REQUEST',
  GET_INTERVIEWABLES_SUCCESS: 'interviews/GET_INTERVIEWABLES_SUCCESS',
  GET_INTERVIEWABLES_FAILURE: 'interviews/GET_INTERVIEWABLES_FAILURE',

  SEND_EMAIL_REQUEST: 'interviews/SEND_EMAIL_REQUEST',
  SEND_EMAIL_SUCCESS: 'interviews/SEND_EMAIL_SUCCESS',
  SEND_EMAIL_FAILURE: 'interviews/SEND_EMAIL_FAILURE',

  CREATE_BULK_REQUEST: 'interviews/CREATE_BULK_REQUEST',
  CREATE_BULK_SUCCESS: 'interviews/CREATE_BULK_SUCCESS',
  CREATE_BULK_FAILURE: 'interviews/CREATE_BULK_FAILURE',

  GET_INTERVIEWS_STATISTICS_REQUEST: 'interviews/GET_INTERVIEWS_STATISTICS_REQUEST',
  GET_INTERVIEWS_STATISTICS_SUCCESS: 'interviews/GET_INTERVIEWS_STATISTICS_SUCCESS',
  GET_INTERVIEWS_STATISTICS_FAILURE: 'interviews/GET_INTERVIEWS_STATISTICS_FAILURE',
};

const initialState = {
  data: [],
  loading: true,
  page: 1,
  total: 0,

  interview: {
    data: {},
    loading: true,
  },

  create: {
    loading: false,
  },

  update: {
    loading: false,
  },

  delete: {
    loading: false,
  },

  interviewable: {
    data: [],
    loading: false,
  },

  email: {
    loading: false,
  },

  bulk: {
    loading: false,
  },

  statistics: {
    data: {
      total: 0,
      finalized: 0,
      not_finalized: 0,
    },
    loading: false,
  },
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case Types.GET_REQUEST:
      return {
        ...state,
        interview: {
          ...state.interview,
          loading: true,
        },
      };
    case Types.GET_SUCCESS:
      return {
        ...state,
        interview: {
          ...state.interview,
          loading: false,
          data: action.payload.interview.data,
        },
      };
    case Types.GET_FAILURE:
      return {
        ...state,
        interview: {
          ...state.interview,
          loading: false,
        },
      };
    case Types.GET_LIST_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case Types.GET_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload.interviews.data,
        page: action.payload.interviews.meta.current_page,
        total: action.payload.interviews.meta.total_count,
      };
    case Types.GET_LIST_FAILURE:
      return {
        ...state,
        loading: false,
      };
    case Types.CREATE_REQUEST:
      return {
        ...state,
        create: {
          ...state.create,
          loading: true,
        },
      };
    case Types.CREATE_SUCCESS:
    case Types.CREATE_FAILURE:
      return {
        ...state,
        create: {
          ...state.create,
          loading: false,
        },
      };
    case Types.UPDATE_REQUEST:
      return {
        ...state,
        update: {
          ...state.update,
          loading: true,
        },
      };
    case Types.UPDATE_SUCCESS:
    case Types.UPDATE_FAILURE:
      return {
        ...state,
        update: {
          ...state.update,
          loading: false,
        },
      };
    case Types.DELETE_REQUEST:
      return {
        ...state,
        delete: {
          ...state.delete,
          loading: true,
        },
      };
    case Types.DELETE_SUCESS:
    case Types.DELETE_FAILURE:
      return {
        ...state,
        delete: {
          ...state.delete,
          loading: false,
        },
      };
    case Types.GET_INTERVIEWABLES_REQUEST:
      return {
        ...state,
        interviewable: {
          ...state.interviewable,
          loading: true,
        },
      };
    case Types.GET_INTERVIEWABLES_SUCCESS:
      return {
        ...state,
        interviewable: {
          ...state.interviewable,
          loading: false,
          data: action.payload.interviewables,
        },
      };
    case Types.GET_INTERVIEWABLES_FAILURE:
      return {
        ...state,
        interviewable: {
          ...state.interviewable,
          loading: false,
        },
      };
    case Types.SEND_EMAIL_REQUEST:
      return {
        ...state,
        email: {
          ...state.email,
          loading: true,
        },
      };
    case Types.SEND_EMAIL_SUCCESS:
    case Types.SEND_EMAIL_FAILURE:
      return {
        ...state,
        email: {
          ...state.email,
          loading: false,
        },
      };
    case Types.CREATE_BULK_REQUEST:
      return {
        ...state,
        bulk: {
          ...state.bulk,
          loading: true,
        },
      };
    case Types.CREATE_BULK_SUCCESS:
    case Types.CREATE_BULK_FAILURE:
      return {
        ...state,
        bulk: {
          ...state.bulk,
          loading: false,
        },
      };
    case Types.GET_INTERVIEWS_STATISTICS_REQUEST:
      return {
        ...state,
        statistics: {
          ...state.statistics,
          loading: true,
        },
      };
    case Types.GET_INTERVIEWS_STATISTICS_SUCCESS:
      return {
        ...state,
        statistics: {
          ...state.statistics,
          data: action.payload.statistics,
          loading: false,
        },
      };
    case Types.GET_INTERVIEWS_STATISTICS_FAILURE:
      return {
        ...state,
        statistics: {
          ...state.statistics,
          loading: false,
        },
      };
    default:
      return state;
  }
}

export const Creators = {
  getInterviewRequest: id => ({
    type: Types.GET_REQUEST,
    payload: { id },
  }),

  getInterviewSuccess: interview => ({
    type: Types.GET_SUCCESS,
    payload: { interview },
  }),

  getInterviewFailure: () => ({
    type: Types.GET_FAILURE,
  }),

  getInterviewsRequest: (page = 1, query = null) => ({
    type: Types.GET_LIST_REQUEST,
    payload: { page, query },
  }),

  getInterviewsSuccess: interviews => ({
    type: Types.GET_LIST_SUCCESS,
    payload: { interviews },
  }),

  getInterviewsFailure: () => ({
    type: Types.GET_LIST_FAILURE,
  }),

  createInterviewRequest: data => ({
    type: Types.CREATE_REQUEST,
    payload: { data },
  }),

  createInterviewSuccess: () => ({
    type: Types.CREATE_SUCCESS,
  }),

  createInterviewFailure: () => ({
    type: Types.CREATE_FAILURE,
  }),

  updateInterviewRequest: (id, data) => ({
    type: Types.UPDATE_REQUEST,
    payload: { id, data },
  }),

  updateInterviewSuccess: () => ({
    type: Types.UPDATE_SUCCESS,
  }),

  updateInterviewFailure: () => ({
    type: Types.UPDATE_FAILURE,
  }),

  deleteInterviewRequest: id => ({
    type: Types.DELETE_REQUEST,
    payload: { id },
  }),

  deleteInterviewSuccess: () => ({
    type: Types.DELETE_SUCCESS,
  }),

  deleteInterviewFailure: () => ({
    type: Types.DELETE_FAILURE,
  }),

  getInterviewableRequest: () => ({
    type: Types.GET_INTERVIEWABLES_REQUEST,
  }),

  getInterviewableSuccess: interviewables => ({
    type: Types.GET_INTERVIEWABLES_SUCCESS,
    payload: { interviewables },
  }),

  getInterviewableFailure: () => ({
    type: Types.GET_INTERVIEWABLES_FAILURE,
  }),

  sendEmailRequest: id => ({
    type: Types.SEND_EMAIL_REQUEST,
    payload: { id },
  }),

  sendEmailSuccess: () => ({
    type: Types.SEND_EMAIL_SUCCESS,
  }),

  sendEmailFailure: () => ({
    type: Types.SEND_EMAIL_FAILURE,
  }),

  createBulkRequest: data => ({
    type: Types.CREATE_BULK_REQUEST,
    payload: { data },
  }),

  createBulkSuccess: () => ({
    type: Types.CREATE_BULK_SUCCESS,
  }),

  createBulkFailure: () => ({
    type: Types.CREATE_BULK_FAILURE,
  }),

  getInterviewsStatistcsRequest: () => ({
    type: Types.GET_INTERVIEWS_STATISTICS_REQUEST,
  }),

  getInterviewsStatistcsSuccess: statistics => ({
    type: Types.GET_INTERVIEWS_STATISTICS_SUCCESS,
    payload: { statistics },
  }),

  getInterviewsStatistcsFailure: () => ({
    type: Types.GET_INTERVIEWS_STATISTICS_FAILURE,
  }),
};

export const Selectors = {
  list: createSelector(
    state => state,
    interviews =>
      interviews.map(interview => ({
        ...interview,
        attributes: {
          ...interview.attributes,
          name: `${interview.attributes.person.name}`,
          created_at: moment(interview.attributes.created_at).format('DD/MM/YYYY [às] HH:mm'),
          updated_at: moment(interview.attributes.updated_at).format('DD/MM/YYYY [às] HH:mm'),
          calculated_at: moment(interview.attributes.calculated_at).format('DD/MM/YYYY [às] HH:mm'),
          course_class: interview.attributes.course_class,
        },
      })),
  ),

  interviewable: createSelector(
    state => state,
    interviewables =>
      interviewables.map(interviewable => ({
        value: interviewable,
        label: interviewable.value,
      })),
  ),
};



// WEBPACK FOOTER //
// ./src/store/ducks/interviews.js